export default "__VITE_ASSET__Dj0pZ6uA__"